// extracted by mini-css-extract-plugin
export default {"container":"LogoSection_container__I6PDj","noTime":"LogoSection_noTime__ClA1g","qute":"LogoSection_qute__rfZBE","bodyText":"LogoSection_bodyText__y4Qgx"};